import { HelmetProvider } from 'react-helmet-async';
import { ToastProvider } from './components/toast/ToastContext';
import { AppRoutes } from './routes';
// import { usePageTracking } from './hooks/use-analytics';

export default function App() {
  return (
    <HelmetProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </HelmetProvider>
  );
}
